import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
//import ReactDOM from "react-dom";
import { MsalProvider } from "@azure/msal-react";
import { Configuration, PublicClientApplication } from "@azure/msal-browser";
import reportWebVitals from './reportWebVitals';


const configuration: Configuration = {
    auth: {
        clientId: process.env.REACT_APP_CLIENTID,
        authority: "https://login.microsoftonline.com/" + process.env.REACT_APP_AZURE_TENANT_ID,
        redirectUri: window.location.origin
    }
};
console.log('Client ID:', process.env.REACT_APP_CLIENTID);
console.log('Tenant ID:', process.env.REACT_APP_AZURE_TENANT_ID);
const pca = new PublicClientApplication(configuration);

// Component
const AppProvider = () => (
    <MsalProvider instance={pca}>
        <App />
    </MsalProvider>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
        <AppProvider />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
